<template>
  <AuthCard>
    <div class="text-center"><h3>Sign in</h3></div>
    <form @submit.prevent="signIn">
      <Input
        ref="emailInput"
        :value="email"
        @input="email = $event"
        label="E-mail"
        name="email"
        :disabled="loading"
      />
      <div class="my-4 position-relative">
        <Input
          :value="password"
          @input="password = $event"
          label="Password"
          name="password"
          type="password"
          :disabled="loading"
          :error="error"
        />
        <RouterLink :to="{ name: 'resetpassword' }" class="forgot-password">
          Forgot password?
        </RouterLink>
      </div>
      <div class="flex wrap align-center">
        <div class="xs12">
          <Button
            type="submit"
            variant="smooth primary"
            :disabled="loading"
            class="mb-2 width100"
            :loading="loading"
          >
            Sign in
          </Button>
        </div>
        <div class="xs12 text-center pt-5">
          Don't have an account?
          <router-link class="ml-3" to="signup">Create an account</router-link>
        </div>
      </div>
    </form>
  </AuthCard>
</template>

<script>
  import Input from '../common/Input.vue'
  import Button from '../common/Button.vue'
  import AuthCard from '../common/AuthCard.vue'

  export default {
    name: 'SignIn',
    components: { Input, Button, AuthCard },
    data: () => ({
      email: '',
      password: '',
      loading: false,
      error: ''
    }),
    mounted() {
      this.$nextTick(() => {
        this.$refs.emailInput?.$el?.querySelector('input')?.focus()
      })
    },
    methods: {
      async signIn() {
        this.loading = true
        this.error = ''
        try {
          await this.$store.dispatch('signIn', { email: this.email, password: this.password })
          this.$router.push({ name: 'home' })
        } catch (e) {
          this.error = e?.response?.data?.message || e?.message || 'Sign in failed. Please try again.'
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style scoped>
.forgot-password {
  position: absolute;
  top: -2px;
  right: 0;
  font-size: 12px;
}
</style>
